var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8034 0L0.231968 6.42857C0.14857 6.51016 0.0891113 6.63583 0.0891113 6.79464C0.0891113 6.93457 0.149993 7.06087 0.231968 7.14286L4.94625 11.8571C5.0313 11.9422 5.12549 12 5.23197 12C5.33845 12 5.43653 11.9348 5.51768 11.8571L12.0891 5.57143V0H6.8034ZM9.66054 1.42857C10.2128 1.42857 10.6605 1.87629 10.6605 2.42857C10.6605 2.98086 10.2128 3.42857 9.66054 3.42857C9.10826 3.42857 8.66054 2.98086 8.66054 2.42857C8.66054 1.87629 9.10826 1.42857 9.66054 1.42857Z",
    fill: "#2D4C5D"
  })));
};
export default SvgSale;